module.exports = __webpack_public_path__ + "static/media/IMG-24.0e72af55.jpg";